import { UpperCasePipe } from '@angular/common';
import { Component, DestroyRef, inject, Signal, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ENVIRONMENT } from '@iot-platform/core';
import { Environment } from '@iot-platform/models/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ReleaseNotesService } from './services/release-notes.service';

@Component({
  imports: [MatCardModule, MatToolbarModule, MatProgressBarModule, UpperCasePipe, MatButtonModule, FlexLayoutModule, MatIconModule, TranslatePipe],
  selector: 'iot-platform-ui-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None
})
export class ReleaseNotesComponent {
  private readonly dialogRef: MatDialogRef<ReleaseNotesComponent> = inject(MatDialogRef<ReleaseNotesComponent>);
  private readonly releaseNotesService: ReleaseNotesService = inject(ReleaseNotesService);
  private readonly sanitizer: DomSanitizer = inject(DomSanitizer);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  public readonly data: { appName: string; changeLog?: boolean } = inject(MAT_DIALOG_DATA);
  currentVersion: Signal<string | undefined> = toSignal(this.releaseNotesService.getCurrentVersion().pipe(takeUntilDestroyed(this.destroyRef)));
  changeLog: Signal<string | undefined> = toSignal(this.releaseNotesService.getChangelog().pipe(takeUntilDestroyed(this.destroyRef)));
  protected readonly environment: Environment = inject(ENVIRONMENT);
  safeUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.environment.api.releaseNotesUrl);

  close() {
    this.dialogRef.close();
  }
}
